// src/components/discovery/ConfidenceDots.jsx
// Visual match confidence indicator: 1–5 filled dots based on 0–1 score.

import React from 'react';
import { Box, Tooltip } from '@mui/material';

const TOTAL = 5;

function scoreToDots(confidence) {
  if (confidence == null) return 0;
  // 0.0→0 dots, 0.85→4 dots, 1.0→5 dots
  return Math.round(confidence * TOTAL);
}

function scoreToLabel(confidence, method) {
  if (confidence == null) return 'No match';
  const pct = Math.round(confidence * 100);
  const methodLabel = {
    ean_exact: 'EAN exact',
    vendor_model: 'Vendor + model',
    fuzzy_name: 'Fuzzy name',
    unmatched: 'Unmatched',
  }[method] || method || 'Unknown';
  return `${methodLabel} — ${pct}% confidence`;
}

export default function ConfidenceDots({ confidence, method, size = 8 }) {
  const filled = scoreToDots(confidence);
  const label = scoreToLabel(confidence, method);

  return (
    <Tooltip title={label} arrow>
      <Box
        display="flex"
        alignItems="center"
        gap={0.4}
        sx={{ cursor: 'default' }}
        aria-label={label}
      >
        {Array.from({ length: TOTAL }, (_, i) => (
          <Box
            key={i}
            sx={{
              width: size,
              height: size,
              borderRadius: '50%',
              bgcolor: i < filled
                ? (filled >= 4 ? 'success.main' : filled >= 2 ? 'warning.main' : 'error.main')
                : 'divider',
              flexShrink: 0,
            }}
          />
        ))}
      </Box>
    </Tooltip>
  );
}
